import { stringArrayToObject } from '../../utils/array';

import { loadAccountCatalog } from '../../services/AccountService';

export const actions = stringArrayToObject([
  'CLEAR',
  'LOAD_START',
  'LOAD_SUCCESS',
  'LOAD_FAIL',
], '@CATALOG');

const privateActionCreators = {
  loadStart(page) {
    return {
      type: actions.LOAD_START,
      payload: { page },
    };
  },
  loadSuccess({ products, page, totalPages }) {
    return {
      type: actions.LOAD_SUCCESS,
      payload: { products, page, totalPages },
    };
  },
  loadFail(error) {
    return {
      type: actions.LOAD_FAIL,
      payload: { error },
    };
  },
};

export const actionCreators = {
  clearCatalog() {
    return {
      type: actions.CLEAR,
    };
  },
  loadCatalog(page = 1) {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadStart(page));
      const response = await loadAccountCatalog(page);
      if (response.ok) {
        dispatch(privateActionCreators.loadSuccess(response));
      } else {
        dispatch(privateActionCreators.loadFail(response.error));
      }
    };
  },
};



// WEBPACK FOOTER //
// ./src/redux/Catalog/actions.js